// const { Timestamp } = require("firebase/firestore");

/**
 * Object for a Blog Message
 */
class BlogMessage {
    /**
     * Creates a new Review Object.
     * @param {String} displayName
     * @param {String} email
     * @param {String} name
     */
    constructor (displayName, createTime, msg,) {
        this.docId;
        this.displayName = displayName;
        this.createTime = createTime;
        this.msg = msg;
    }
}

// Firestore data converter
const BlogMessageConverter = {
    /**
     * Converts the BlogMessage to a firestore document.
     * 
     * @param {BlogMessage} review
     * Holds the BlogMessage object we want in the DB.
     * 
     * @returns {JSON}
     * Firestore JSON object of the BlogMessage.
     */
    toFirestore: (msg) => {
        return {
            displayName: msg.displayName,
            createTime: msg.createTime,
            msg: msg.msg,
        };
    },

    /**
     * Converts a Firestore document to a BlogMessage object.
     * 
     * @param {*} snapshot 
     * @param {*} options 
     * @returns {BlogMessage}
     * a BlogMessage object.
     */
    fromFirestore: (snapshot, options) => {
        const data = snapshot.data(options);
        let r =  new BlogMessage(
            data.displayName,
            data.createTime,
            data.msg,
        )

        r.docId = snapshot.id;
        return r;
    }
};

module.exports = { BlogMessage, BlogMessageConverter }
